/* ScrollToTop — single source of truth for scroll-on-navigation.
 *
 * Mounted inside <BrowserRouter>, it scrolls the window back to (0, 0) every
 * time `location.pathname` changes. This fixes the bug where clicking a
 * footer link (or any link that lives deep in the page) opens the new route
 * but leaves the viewport scrolled to wherever the previous click was — a
 * jarring experience on mobile in particular, where the user can't tell the
 * page has changed at all.
 *
 * We intentionally ignore `hash` changes (anchor links) so in-page jump links
 * still work normally — e.g. `/blog/x#section`.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // `instant` so users on a long page don't see an awkward scroll-up
    // animation when they tap a footer link.
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      // Older Safari versions don't accept the object form.
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
